import { FC } from 'react';
import { Box, Link, Stack, Typography } from '@mui/material';

interface ViewProps extends Universities.University {
}

export const ViewUniversityAdmissionContacts: FC<ViewProps> = university => {
  return (
    <Box
      pt={1}
      pb={2}
      px={2}
      width="100%"
      sx={theme => ({
        backgroundColor: theme.palette.background.default,
        borderBottomLeftRadius: {
          sm: 6,
        },
        borderBottomRightRadius: {
          sm: 6,
        },
      })}
    >
      <Box
        mb={2}
      >
        {university.contactPerson && (
          <Box display="inline-block" mr={2} mb={1}>
            <Stack>
              <Typography variant="subtitle1" mb={0.5}>Contact Person</Typography>
              <Typography variant="body1">{university.contactPerson}</Typography>
            </Stack>
          </Box>
        )}
        {university.admissionsContact && (
          <Box maxWidth="100%" display="inline-block" mr={2} mb={1}>
            <Stack>
              <Typography variant="subtitle1" mb={0.5}>Email</Typography>
              <Link href={`emailto:${university.admissionsContact}`} underline="hover" color="inherit">
                <Typography variant="body1" whiteSpace="nowrap" textOverflow="ellipsis" overflow="hidden">
                  {university.admissionsContact}
                </Typography>
              </Link>
            </Stack>
          </Box>
        )}
        {university.admissionsPhone && (
          <Box display="inline-block" mr={2} mb={1}>
            <Stack>
              <Typography variant="subtitle1" mb={0.5}>Phone</Typography>
              <Typography variant="body1">{university.admissionsPhone}</Typography>
            </Stack>
          </Box>
        )}
      </Box>
      {university.immigrationSupport && (
        <>
          <Typography variant="subtitle1" mb={0.5}>Imigration Support</Typography>
          <Typography variant="body1">{university.immigrationSupport}</Typography>
        </>
      )}
    </Box>
  );
};
